import { ref } from 'vue';
import { defineStore } from 'pinia';
import { IFilter } from '@/interfaces/filter/IFilter';

export const useFilterStore = defineStore('filterStore', () => {
    const activeFilters = ref<IFilter[]>([]);
    const activeSearchFilters = ref<string[]>([]);
    const searchQuery = ref<string>('');
    const showAdvancedFilter = ref(false);
    const filterPanelOpen = ref(true);

    return {
        activeFilters,
        activeSearchFilters,
        showAdvancedFilter,
        searchQuery,
        filterPanelOpen,
    }
})
